import { useEffect, useState } from "react";
import styles from "./styles.module.css";
import styled from "styled-components";
import KeyboardDoubleArrowUpRoundedIcon from "@mui/icons-material/KeyboardDoubleArrowUpRounded";
import KeyboardDoubleArrowDownRoundedIcon from "@mui/icons-material/KeyboardDoubleArrowDownRounded";

const ContainerBar = styled.div`
  width: 100vw;
  height: ${({ open }) => (open ? "4rem" : "0")};
  transition: all 0.5s ease-in-out;
  transform-origin: top;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 8px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  gap: 10px;
  align-items: center;
  backdrop-filter: blur(10px);
  box-shadow: 2px 2px 8px #00000091;
  padding-inline: 1rem;
`;

const ToolBar = ({ children }) => {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const { scrollTop, scrollHeight, clientHeight } =
        document.documentElement;

      if (Math.ceil(scrollTop + clientHeight) >= Math.floor(scrollHeight)) {
        setOpen(false);
      } else {
        setOpen(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <div className={styles.bar}>
        <ContainerBar open={open}>{children}</ContainerBar>
        <button
          title={open ? "Ocultar opções" : "Mais Opções"}
          className={styles.btn__bar}
          onClick={() => setOpen(!open)}
        >
          {open ? (
            <KeyboardDoubleArrowUpRoundedIcon fontSize="1.5rem" />
          ) : (
            <KeyboardDoubleArrowDownRoundedIcon fontSize="1.5rem" />
          )}
        </button>
      </div>
    </>
  );
};

export default ToolBar;
